import React, { useEffect, useState } from "react";
import { Container, Spinner, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { MdAddCircleOutline, MdDeleteOutline, MdOutlineEdit } from "react-icons/md";
import { useSelector } from "react-redux";
import ComponentMenu from "../../components/layout/ComponentMenu";
import ComponentTitle from "../../components/layout/ComponentTitle";
import { apiGetUsages } from "../../api/ApiUsage";
import ModalCreateUpdate from "../../components/admin/usage/ModalCreateUpdate";
import ModalDelete from "../../components/admin/usage/ModalDelete";

const PageAdminUsages = () => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const [idUsage, setIdUsage] = useState("");
  const [usages, setUsages] = useState([]);
  const [showCreateUpdate, setShowCreateUpdate] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [loading, setLoading] = useState(false);

  const recupUsages = async () => {
    setLoading(true);
    const res = await apiGetUsages(ReduxInstance._id);
    if (res) {
      setUsages(res.data);
      setLoading(false);
    } else {
      console.log("Error");
    }
  };

  const handleShowCreateUpdate = (id) => {
    setIdUsage(id);
    setShowCreateUpdate(true);
  };

  const handleCloseCreateUpdate = () => {
    setIdUsage(null);
    setShowCreateUpdate(false);
  };

  const handleShowDelete = (id) => {
    setIdUsage(id);
    setShowDelete(true);
  };

  const handleCloseDelete = () => {
    setIdUsage(null);
    setShowDelete(false);
  };

  useEffect(() => {
    recupUsages();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <ComponentMenu />
      <Container>
        <ComponentTitle title={t("admin.PageAdminUsages.titre")} />
        <span role="button" onClick={() => handleShowCreateUpdate("")}>
          <MdAddCircleOutline size="1.5em" /> {t("admin.PageAdminUsages.buttonAjouterUsage")}
        </span>
        {loading ? (
          <div style={{ textAlign: "center", flex: 1 }}>
            <Spinner animation="grow" />
          </div>
        ) : (
          <Table striped bordered hover className="stickyTable mt-2">
            <thead>
              <tr>
                <th>{t("admin.PageAdminUsages.titreColonne1")}</th>
                <th className="text-center">{t("admin.PageAdminUsages.titreColonne2")}</th>
                <th className="text-center">{t("admin.PageAdminUsages.titreColonne3")}</th>
              </tr>
            </thead>
            <tbody>
              {usages.map((usage) => (
                <tr key={usage._id}>
                  <td>{usage.nom}</td>
                  <td className="text-center">
                    <MdOutlineEdit
                      size="1.5em"
                      role="button"
                      onClick={() => handleShowCreateUpdate(usage._id)}
                    />
                  </td>
                  <td className="text-center">
                    <MdDeleteOutline
                      size="1.5em"
                      role="button"
                      onClick={() => handleShowDelete(usage._id)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}

        <ModalCreateUpdate
          show={showCreateUpdate}
          id={idUsage}
          handleClose={handleCloseCreateUpdate}
          handleRecupDatas={recupUsages}
        />
        <ModalDelete
          show={showDelete}
          id={idUsage}
          handleClose={handleCloseDelete}
          handleRecupDatas={recupUsages}
        />
      </Container>
    </>
  );
};

export default PageAdminUsages;
